import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
} from "@chakra-ui/react";
import {
  Box,
  Button,
  Flex,
  Image,
  Text,
  VStack,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import {
  capitalize,
  excludeSubjects,
  isNotEmptyOrNull,
  tutorString,
  urlString,
} from "../../../utils/common-utils.js";
import {
  getSectionSubjectTree,
  getSectionSubjectTreeV3,
  getSubjects,
  getSubjectsForStandalone,
  getTopicsForStandalone,
} from "../../../network/LearnApiService.jsx";
import { useEffect, useState } from "react";

import ArrowDownIcon from "../../../assets/svgs/arrow-down.svg";
import ArrowRightIcon from "../../../assets/svgs/arrow-right.svg";
import AskDoubtAccordion from "../accordionComponents/AskDoubtAccordion.jsx";
import Assistant from "../ai-tutor/Assistant/Assistant.jsx";
import { GET_DATA } from "../../../network/graphql/Learn.js";
import RESOURCES from "../../../resourses/RESOURCES.js";
import SubjectSelector from "../SubjectSelector/SubjectSelector.jsx";
import accordion_images from "../../../utils/accordion/accordion_images.jsx";
import emotionalMessages from "../../../utils/emotionalScriptConstants.js";
import excludeSubject from "../../../utils/excludeSubject.js";
import { getRandomVinMessage } from "../../../network/LearnApiService.jsx";
import { taskTypes } from "../../../utils/LearningPathUtils.js";
import { testData } from "../../../utils/constants.js";
import { useNavigate } from "@remix-run/react";
import { useQuery } from "@apollo/client/index.js";
import { useRoot } from "../../../context/RootContext.jsx";
import useStateRef from "react-usestateref";
import { useTutor } from "../../../context/AiTutorContext.jsx";
import { StorageService } from "../../../utils/StorageUtils.js";

const MODE = [
  { _id: "0", modeName: "Assessment" },
  { _id: "2", modeName: "Practice" },
];

let USER_FIRSTNAME = "";

export default function TopicSelector(props) {
  const [activeButton, setActiveButton, activeButtonRef] = useStateRef(
    MODE[1].modeName
  );
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedTopic, setSelectedChapter] = useState(null);
  const [selectedSubtopic, setSelectedSubtopic] = useState(null);
  const [topicList, setTopicList] = useState([]);
  const [taskProgressId, setTaskProgressId] = useState("");
  const [studentId, setStudentId] = useState("");
  const [onClickSubject, setOnClickSubject] = useState(null);
  const {
    setSubjectId,
    setSubject,
    setSubjectMasterUUid,
    setTopic,
    setTopicMasterUuid,
    setSubtopicId,
  } = useTutor();
  const [subjectsList, setSubjectsList] = useState([]);
  const [latestTasksList, setLatestTasksList] = useState([]);
  const [
    customAssessmentTopicsUnlockedList,
    setCustomAssessmentTopicsUnlockedList,
  ] = useState([]);
  const {
    userDetails,
    selectedIndex,
    isTutor,
    isStandaloneWithSubjectMapping,
    setSubjectName,
    subTopicName,
    topicName,
    subjectName,
    setSubTopicName,
    setTopicName,
    handleTakeupNextTask,
  } = useRoot();
  const [fullTabs, setFullTabs] = useState(false);
  const [stepOne, setStepOne, stepOneRef] = useStateRef(false);
  const [stepTwo, setStepTwo, stepTwoRef] = useStateRef(false);
  const [stepThree, setStepThree, stepThreeRef] = useStateRef(false);
  const [topicsListing, setTopicsListing, topicsListingRef] = useStateRef([]);
  const [assistantText, setAssistantText] = useState("Loading....");
  // const [emotionalMessageCode, setEmotionalMessageCode] = useState(0);
  const [isNotFromUpdate, setIsNotFromUpdate] = useState(false);
  const [
    userAdditionalDetails,
    setUserAdditionalDetails,
    userAdditionalDetailsRef,
  ] = useStateRef({});

  const [hasHydrated, setHasHydrated] = useState(false);
  const navigate = useNavigate();

  const toggleAccordion = () => {
    // console.log("NICE");
    setFullTabs(!fullTabs);
    setSubjectName("");
    setTopicName("");
    setSubTopicName("");
  };

  // useEffect(() => {
  //   console.log("hi");
  //   toggleAccordion();
  // }, []);

  useEffect(() => {
    const value = StorageService.getItem("redirectObject");
    if (value) {
      const redirectObject = JSON.parse(value);
      const {
        subjectId,
        subjectName,
        subjectMasterId,
        topicId,
        topicName,
        subtopicId,
        subtopicName,
        taskType,
      } = redirectObject;

      setSubject(subjectName);
      setSubjectId(subjectId);
      setSubjectMasterUUid(subjectMasterId);
      setTopic(topicName);
      setTopicMasterUuid(topicId);
      setSubTopicName(subtopicName);
      setSubtopicId(subtopicId);
      setSelectedSubTopic({
        id: subtopicId,
        taskType:
          taskType == 1 || taskType == 3
            ? taskTypes.guidedPractice
            : taskTypes.assessment,
      });
    }
  }, []);
  const openStepOne = () => {
    setStepOne((prev) => !prev);
    setStepTwo(false);
    setStepThree(false);
  };
  const openStepTwo = () => {
    setStepTwo((prev) => !prev);
    setStepOne(false);
    setStepThree(false);
  };
  const openStepThree = () => {
    if (props?.unlockProps && !isNotFromUpdate) {
      setStepThree(true);
    } else {
      setStepThree((prev) => !prev);
    }
    setStepTwo(false);
    setStepOne(false);
    setIsNotFromUpdate(true);
  };

  useEffect(() => {
    setStudentId(StorageService.getItem("student_id"));
    if (location.pathname.includes("doubt")) {
      setSubjectName(props?.subjectName);
      setTopicName(props?.topicName);
      setSubjectMasterUUid(props?.subjectMasterUuid);
      setTopicMasterUuid(props?.topicMasterUuid);
      setSubjectId(props?.subject);
      setSubject(props?.subject);
      setTopic(props?.topic);
    }
    let details = StorageService.getItem("user_additional_details");
    details = typeof details === "object" ? details : JSON.parse(details);
    if (details) {
      setUserAdditionalDetails(details);
    }
  }, []);

  useEffect(() => {
    // console.log("handleTakeupNextTask", handleTakeupNextTask);
    if (handleTakeupNextTask) {
      setSubjectName("");
      setTopicName("");
      setSubTopicName("");
    }
  }, [handleTakeupNextTask]);

  useEffect(() => {
    if (selectedIndex === 4) {
      setActiveButton(MODE[1]);
    } else if (selectedIndex === 5) {
      setActiveButton(MODE[0]);
    }
    // setEmotionalCode();
  }, [selectedIndex]);

  const filteredSubjectList = (subjects) => {
    const excludeLower = excludeSubject.map((subject) => subject.toLowerCase());
    return subjects.filter(
      (subject) => !excludeLower.includes(subject.name.toLowerCase())
    );
  };

  const getSubjectsData = async (gradeId) => {
    let subjects = [];
    let latestTasks = [];
    let customSubtopicTopics = [];
    if (selectedIndex == 3 || (selectedIndex == 2 && isTutor)) {
      subjects = await getSubjectsForStandalone(gradeId);
    } else {
      // subjects = await getSubjects(gradeId);
      // console.log("DATA", userAdditionalDetailsRef?.current);
      let payload = {
        schoolId: userAdditionalDetailsRef?.current?.schoolId,
        gradeId: userAdditionalDetailsRef?.current?.schoolGradeId,
        sectionId: userAdditionalDetailsRef?.current?.sectionId,
        academicYearId: userAdditionalDetailsRef?.current?.academicYearId,
      };

      const {
        latestTasks: latesttasks,
        subjects: fetchedSubjects,
        customSubtopicTopics: customsubtopictopics,
      } = await getSectionSubjectTreeV3(payload);
      latestTasks = latesttasks;
      subjects = fetchedSubjects;
      customSubtopicTopics = customsubtopictopics;
    }
    if (selectedIndex == 2) {
      subjects = handleExcludeSubjects(subjects);
    }
    setSubjectsList(subjects);
    setLatestTasksList(latestTasks);
    setCustomAssessmentTopicsUnlockedList(customSubtopicTopics);
    // console.log("SUBJECTS", subjects);

    if (props?.openFull && props?.unlockProps && !isNotFromUpdate) {
      setFullTabs(true);
      setSubjectName(props?.unlockProps?.updateData?.subjectName);
      setTopicName(props?.unlockProps?.updateData?.topicName);
      setSubTopicName(props?.unlockProps?.updateData?.subtopicName);
      setSubjectMasterUUid(props?.unlockProps?.updateData?.subjectMasterUuid);
      const neededSubject = subjects.find((subject) => {
        return (
          subject?.master_uuid ===
          props?.unlockProps?.updateData?.subjectMasterUuid
        );
      });
      const matchingTopic = neededSubject?.topicDetails.find(
        (topicDetail) =>
          topicDetail?.topic?.topicMasterUuid ===
          props?.unlockProps?.updateData?.topicMasterUuid
      );
      const matchingSubtopic = matchingTopic?.subtopics.find(
        (subtopicDetail) =>
          subtopicDetail?.subtopicMasterUuid ===
          props?.unlockProps?.updateData?.subtopicMasterUuid
      );
      //console.log("MAtch", matchingTopic);
      setTopicList(neededSubject?.topicDetails);
      setSelectedChapter(matchingTopic);
      setSelectedSubtopic(matchingSubtopic);
      openStepThree();
    }
  };
  const { setSelectedTopic, setSelectedSubTopic } = useTutor();

  useEffect(() => {
    getSubjectsData(StorageService.getItem("gradeId"));
    let details = StorageService.getItem("user_additional_details");
    details = typeof details === "object" ? details : JSON.parse(details);
    USER_FIRSTNAME = userDetails?.firstName
      ? userDetails?.firstName
      : details?.firstName
      ? details?.firstName
      : "";
  }, []);
  const onTopicSelector = (selectedSubtopic, topic) => {
    // console.log(selectedSubtopic, topic, ">topic");
    setSubTopicName(selectedSubtopic?.name);
    setSelectedTopic(topic);
    setSelectedSubTopic(selectedSubtopic);
  };
  const handleExcludeSubjects = (subjects) => {
    // console.log("exclude subjects---", excludeSubjects);
    return subjects.filter(
      (subject) => !excludeSubjects.includes(subject.name.toLowerCase())
    );
  };

  const createDictionary = (subjectMasterUuid) => {
    const subject = subjectsList.find(
      (subject) => subject.master_uuid === subjectMasterUuid
    );
    const topicsList = subject?.topicDetails;
    // console.log(topicsList, "Raghavendra");
    setTopicList(topicsList);
  };

  const getStandaloneTopicsData = async (subjectId) => {
    let topics = await getTopicsForStandalone(subjectId);
    topics = topics?.map((item) => {
      let subTopics = [...(item.subtopic || [])];
      subTopics = subTopics?.map((item) => {
        return { ...item, id: item?._id };
      });
      return { ...item, subtopic: subTopics, locked: false, progress: [] };
    });
    setTopicList(topics || []);
  };

  const handleSelectSubject = (subject, subjectId, subjectName, journeyId) => {
    if (selectedIndex == 3 || (selectedIndex == 2 && isTutor)) {
      getStandaloneTopicsData(subjectId);
    } else {
      // getTopicsData(subject);
      createDictionary(subject);
    }
    setSelectedSubject(subject);
    setSubjectMasterUUid(subject);
    setSubjectId(subjectId);
    setSubject(subjectName);
    setSelectedChapter();
  };

  const handleSelectTopic = (chapter) => {
    setSelectedChapter(chapter);
  };

  // const setEmotionalCode = () => {
  //   if (isStandaloneWithSubjectMapping) {
  //     if (selectedIndex == 3) {
  //       setEmotionalMessageCode(5);
  //     }
  //   } else {
  //     if (selectedIndex == 1) {
  //       setEmotionalMessageCode(9);
  //     } else if (selectedIndex == 4) {
  //       setEmotionalMessageCode(5);
  //     } else if (selectedIndex == 5) {
  //       setEmotionalMessageCode(1);
  //     }
  //   }
  // };

  useEffect(() => {
    if (selectedIndex === 4) {
      setActiveButton(MODE[1].modeName);
    } else if (selectedIndex === 5) {
      setActiveButton(MODE[0].modeName);
    } else {
      setActiveButton("");
    }
  }, []);

  useEffect(() => {
    setHasHydrated(true);
  }, []);

  if (!hasHydrated) {
    return null;
  }

  // console.log("SUBJECTS LIST", subjectsList);
  return (
    <VStack alignItems="flex-start" overflow="hidden" w={"100%"}>
      {selectedIndex !== 2 && selectedIndex !== 3 && (
        <Assistant
          text={""}
          emotionalMessageCode={14}
          isEmotionalScript={true}
        />
      )}
      <Box
        w={["100%", "80%", "80%", "80%", "60%"]}
        background="white"
        marginLeft={{ base: "0px", md: "40px", lg: "50px" }}
        //marginLeft="50px"
        alignContent="center"
        alignItems="center"
        paddingTop="14px"
        // paddingRight="32px"
        // paddingLeft="32px"
        borderRadius={"10px"}
        borderTopRightRadius={"0px"}
        borderTopLeftRadius={"0px"}
      >
        {!isNotEmptyOrNull(subjectName) && (
          <Accordion
            borderColor="transparent"
            w="100%"
            sx={{ "-webkit-tap-highlight-color": "transparent" }}
          >
            <AccordionItem
              borderBottomWidth={fullTabs ? "2px" : ""}
              borderBottomColor={fullTabs ? "#ccc" : ""}
            >
              <h2>
                <AccordionButton
                  data-testid="accordian view"
                  onClick={toggleAccordion}
                  paddingRight="32px"
                  paddingLeft="32px"
                  _hover={{ bgColor: "transparent" }}
                >
                  <Text
                    flex="1"
                    textAlign="left"
                    fontSize="14px"
                    marginBottom="10px"
                    lineHeight="21px"
                    fontWeight={400}
                    fontFamily="Text-sm/Regular"
                    color="#5F4DC7"
                  >
                    {"Select Subject > Chapter" +
                      (selectedIndex != 2 ? " > Subtopic" : "")}
                  </Text>
                  <Image
                    style={{ marginBottom: "10px" }}
                    src={fullTabs ? ArrowRightIcon : ArrowDownIcon}
                    transform={fullTabs ? "rotate(270deg)" : " "}
                  />
                </AccordionButton>
              </h2>
            </AccordionItem>
          </Accordion>
        )}
        {fullTabs && (
          <Box>
            <Accordion
              borderColor="transparent"
              w="100%"
              sx={{ "-webkit-tap-highlight-color": "transparent" }}
            >
              <AccordionItem>
                <h2
                  style={{
                    borderBottomWidth: "1px",
                    borderBottomColor: "#ccc",
                  }}
                >
                  <AccordionButton
                    onClick={() => {
                      openStepOne();
                    }}
                    paddingRight="32px"
                    paddingLeft="32px"
                    _hover={{ bgColor: "transparent" }}
                  >
                    <Text
                      flex="1"
                      textAlign="left"
                      fontSize="16px"
                      lineHeight="21px"
                      fontWeight={600}
                      fontFamily="Text-sm/Semibold"
                      color="#5F4DC7"
                    >
                      {isNotEmptyOrNull(subjectName) ? subjectName : "Subject"}
                    </Text>
                    {/* <Image src={ArrowRightIcon} /> */}
                    <Image
                      src={stepOneRef.current ? ArrowDownIcon : ArrowRightIcon}
                    />
                  </AccordionButton>
                </h2>

                {stepOneRef.current &&
                  subjectsList?.map((subject, index) => (
                    <AccordionPanel
                      data-testid={`subject-${index}`}
                      pb={4}
                      _hover={{
                        bgColor: "#FFDFDB",
                      }}
                      onClick={() => {
                        handleSelectSubject(
                          subject.master_uuid,
                          subject._id,
                          subject.name
                        );
                        setSubjectName(subject.name);
                        setTopicName("");
                        setSubTopicName("");
                        openStepTwo();
                        setOnClickSubject(subject);
                        setIsNotFromUpdate(true);
                      }}
                    >
                      <Box cursor="pointer">
                        <Text
                          flex="1"
                          textAlign="left"
                          fontSize="14px"
                          paddingLeft="12px"
                          lineHeight="18px"
                          fontWeight={400}
                          fontFamily="Text-xs/Regular"
                          color="#302884"
                        >
                          {capitalize(subject.name)}
                        </Text>
                      </Box>
                    </AccordionPanel>
                  ))}

                <h2
                  style={{
                    borderBottomWidth: "1px",
                    borderBottomColor: "#ccc",
                  }}
                >
                  <AccordionButton
                    onClick={() => {
                      openStepTwo();
                    }}
                    paddingRight="32px"
                    paddingLeft="32px"
                    _hover={{ bgColor: "transparent" }}
                  >
                    <Text
                      flex="1"
                      textAlign="left"
                      fontSize="16px"
                      lineHeight="21px"
                      fontWeight={600}
                      fontFamily="Text-sm/Semibold"
                      color="#5F4DC7"
                    >
                      {isNotEmptyOrNull(topicName) ? topicName : "Chapter"}
                    </Text>
                    <Image
                      src={stepTwoRef.current ? ArrowDownIcon : ArrowRightIcon}
                    />
                  </AccordionButton>
                  {/* ASK YOUR DOUBT */}
                  {stepThreeRef.current && selectedTopic && (
                    <AskDoubtAccordion
                      isTutor={isTutor}
                      selectedTopic={selectedTopic}
                      onClickSubject={onClickSubject}
                    />
                  )}
                </h2>
                {stepTwoRef.current &&
                  topicList?.map((topic, index) => (
                    <AccordionPanel
                      data-testid={`topic-${index}`}
                      pb={4}
                      key={topic._id}
                      _hover={{
                        bgColor: "#FFDFDB",
                      }}
                      onClick={() => {
                        //setTopicName(topic?.topic?.topicInfo?.name);
                        setTopicName(
                          selectedIndex === 3 ||
                            (selectedIndex === 2 && isTutor)
                            ? topic?.name
                            : topic?.topic?.topicInfo?.name
                        );
                        setSubTopicName("");
                        handleSelectTopic(topic);
                        if (selectedIndex !== 2) {
                          openStepThree();
                        } else {
                          setTopic(
                            isTutor
                              ? topic?.name
                              : topic?.topic?.topicInfo?.name
                          );
                          setTopicMasterUuid(
                            isTutor
                              ? topic?.masterId
                              : topic?.topic?.topicInfo?.master_uuid
                          );
                        }
                      }}
                    >
                      <Box cursor="pointer" w="100%">
                        <Text
                          flex="1"
                          textAlign="left"
                          fontSize="14px"
                          paddingLeft="12px"
                          lineHeight="18px"
                          fontWeight={400}
                          fontFamily="Text-xs/Regular"
                          color="#302884"
                        >
                          {selectedIndex == 3 || (selectedIndex == 2 && isTutor)
                            ? topic?.name
                            : topic?.topic?.topicInfo?.name}
                        </Text>
                      </Box>
                    </AccordionPanel>
                  ))}

                <h2>
                  {selectedIndex !== 2 && (
                    <AccordionButton
                      onClick={openStepThree}
                      paddingRight="32px"
                      paddingLeft="32px"
                      _hover={{ bgColor: "transparent" }}
                    >
                      <Text
                        flex="1"
                        textAlign="left"
                        fontSize="16px"
                        lineHeight="21px"
                        fontWeight={600}
                        fontFamily="Text-sm/Semibold"
                        color="#5F4DC7"
                      >
                        {isNotEmptyOrNull(subTopicName)
                          ? subTopicName
                          : "Subtopic"}
                      </Text>
                      <Image
                        src={
                          stepThreeRef.current ? ArrowDownIcon : ArrowRightIcon
                        }
                      />
                    </AccordionButton>
                  )}
                </h2>
                {stepThreeRef.current && (
                  <VStack
                    alignItems="flex-start"
                    w="100%"
                    overflowY="scroll"
                    paddingBottom={5}
                    css={{
                      "&::-webkit-scrollbar": {
                        width: "8px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: RESOURCES.colors.LIGHT_WISTERIA,
                      },
                    }}
                  >
                    {selectedTopic && (
                      <SubjectSelector
                        onTopicSelector={onTopicSelector}
                        key={selectedTopic?.topic?.topicId}
                        setSelectedSubtopic={setSelectedSubtopic}
                        selectedSubtopic={selectedSubtopic}
                        topics={selectedTopic}
                        mode={activeButton}
                        isLearn={
                          !(
                            selectedSubject &&
                            (selectedIndex === 4 || selectedIndex === 5)
                          )
                        }
                        isSideNav={false}
                        latestTasksList={latestTasksList}
                        customAssessmentTopicsUnlockedList={
                          customAssessmentTopicsUnlockedList
                        }
                      />
                    )}
                  </VStack>
                )}
              </AccordionItem>
            </Accordion>
          </Box>
        )}
      </Box>
    </VStack>
  );
}
